import { cut } from "react-native-jieba";

export type Token = { end: number; start: number; word: string };

// react-native-jieba doesn't expose `tokenize`, so synthesize it from `cut` by
// walking input offsets. cppjieba emits words in document order with no overlap,
// so a moving index that scans for each word from where the previous one ended
// reconstructs the same offsets the wasm `tokenize` would return.
export function tokenize(text: string, _mode: string = "default", hmm: boolean = true): Token[] {
  const words = cut(text, hmm);
  const tokens: Token[] = [];
  let cursor = 0;
  for (const word of words) {
    const start = text.indexOf(word, cursor);
    if (start === -1) {
      continue;
    }
    const end = start + word.length;
    tokens.push({ end, start, word });
    cursor = end;
  }
  return tokens;
}
